import _ from "lodash";
import { InputSelector } from "../../components/Forms/InputSelector";
import { IBaseFormProps } from "../../components/interfaces";
import { useState } from "react";
import { twMerge } from "tailwind-merge";
import { FieldName } from "../../components/Forms/Inputs";

/**
 *
 * @param schema loaded schema
 * @param modelName name of model
 * @param itemData itemData state
 * @param setItemData setItemData state
 * @returns
 */

const UsersForm = ({
  schema,
  modelName,
  itemData,
  setItemData,
  customModel,
}: IBaseFormProps): JSX.Element => {
  const updateItemData = (keyname: string, value: any) => {
    if (_.has(itemData, keyname))
      setItemData({
        ...itemData,
        [keyname]: value,
      });
  };

  const filteredSchema = schema.filter(
    (field) => !_.includes(["password", "confirmPassword"], field.name)
  );

  const PasswordHint = () => (
    <div className="text-xs opacity-60">
      {customModel === "updateUser" && (
        <div>Leave this blank if you do not wish to change the password.</div>
      )}
      Must have at least 8 characters, a number, capital letter and a special
      character.
    </div>
  );

  return (
    <form>
      <div className="flex flex-col gap-4">
        {filteredSchema.map((item, index) => (
          <InputSelector
            value={itemData[item.name]}
            key={index}
            onChange={(e) => {
              updateItemData(item.name, e.target.value);
            }}
            modelname={modelName}
            customModel={customModel}
            {...item}
          />
        ))}
        <div className="mb-2 space-y-1">
          <FieldName name="Password" />
          <PasswordHint />
          <input
            type="password"
            name="password"
            className="w-full border border-[#ccc] p-2.5 text-sm"
            id={`form_password`}
            onChange={(e) => {
              updateItemData("password", e.target.value);
            }}
          />
        </div>
        <div className="mb-2 space-y-1">
          <FieldName name="Confirm Password" />
          <input
            type="password"
            name="confirmPassword"
            className="w-full border border-[#ccc] p-2.5 text-sm"
            id={`form_confirmPassword`}
            onChange={(e) => {
              updateItemData("confirmPassword", e.target.value);
            }}
          />
        </div>
      </div>
    </form>
  );
};

export default UsersForm;
